
























































import Component from 'vue-class-component';
import Vue from 'vue';
import FirebaseGateway from '../../../classes/firebaseGateway';
import FirebaseRealtime from '../../../classes/firebaseRealtime';

@Component
export default class Session extends Vue {
  private loading = true;
  private rtc!: RTCPeerConnection;
  private logs: string[] = [];

  get session() {
    return this.$store.getters.session;
  }

  get userId() {
    return this.$store.getters.userId;
  }

  public startSession() {
    this.$store.dispatch('startSession');
  }

  public stopSession() {
    this.logs = [];
    this.$store.dispatch('stopSession');
  }

  private showMyFace() {
    const yourVideo = document.getElementById('yourVideo') as HTMLVideoElement;
    if (yourVideo === null) {
      throw new Error('Your video not found');
    }
    if (this.rtc === null) {
      throw new Error('Remote connection not created');
    }
    return (navigator.mediaDevices as any)
      .getDisplayMedia({ audio: true, video: true })
      .then((stream) => {
        yourVideo.srcObject = stream;
        return stream;
      })
      .then((stream) => {
        if (this.rtc === null) {
          throw new Error('Remote connection not created');
        }
        // this.rtc.addTrack(stream.getVideoTracks()[0], stream);
        if (stream.getAudioTracks().length > 0) {
          this.rtc.addTrack(stream.getAudioTracks()[0], stream);
        }
        return true;
      })
      .catch((error) => {
        console.log(error, error.name, error.message);
      });
  }

  private offerAudio() {
    const servers = {
      iceServers: [
        { urls: 'stun:stun.services.mozilla.com' },
        { urls: 'stun:stun.l.google.com:19302' },
        // { urls: 'turn:numb.viagenie.ca', credential: 'beaver', username: 'webrtc.websitebeaver@gmail.com' },
      ],
    };
    this.rtc = new RTCPeerConnection(servers);
    this.rtc.onicecandidate = (event) => {
      this.logs.push('onCandidate', JSON.stringify(event));
      if (event.candidate) {
        this.sendMessage(JSON.stringify({ ice: event.candidate }));
      } else {
        this.logs.push('Sent All Ice');
      }
    };
    FirebaseRealtime.watchSessionMessages(this.session.owner, this.readMessage);
    this.rtc.ontrack = (event) => {
      const friendsVideo = document.getElementById('friendsVideo') as HTMLVideoElement;
      friendsVideo.srcObject = event.streams[0];
    };
    this.showMyFace().then(() => {
      this.$store.dispatch('setSessionAudio', true);
      this.rtc
        .createOffer()
        .then((offer) => this.rtc.setLocalDescription(offer))
        .then(() => this.sendMessage(JSON.stringify({ sdp: this.rtc.localDescription })));
    });
  }

  private connectAudio() {
    const servers = {
      iceServers: [
        { urls: 'stun:stun.services.mozilla.com' },
        { urls: 'stun:stun.l.google.com:19302' },
        // { urls: 'turn:numb.viagenie.ca', credential: 'beaver', username: 'webrtc.websitebeaver@gmail.com' },
      ],
    };
    this.rtc = new RTCPeerConnection(servers);
    this.rtc.onicecandidate = (event) => {
      console.log('onCandidate', event);
      event.candidate ? this.sendMessage(JSON.stringify({ ice: event.candidate })) : console.log('Sent All Ice');
    };
    FirebaseRealtime.watchSessionMessages(this.session.owner, this.readMessage);
    this.rtc.ontrack = (event) => {
      const friendsVideo = document.getElementById('friendsVideo') as HTMLVideoElement;
      friendsVideo.srcObject = event.streams[0];
    };
  }

  private sendMessage(data) {
    this.logs.push('sending: ' + data);
    FirebaseRealtime.sendSessionMessage(this.session.owner, this.userId, data);
  }

  private readMessage(data) {
    if (this.rtc === null) {
      throw new Error('RTC connection not enabled');
    }
    const msg = JSON.parse(data.message);

    const sender = data.sender;
    if (sender !== this.userId) {
      try {
        if (msg.ice !== undefined) {
          this.logs.push('addIceCandidate');
          this.rtc.addIceCandidate(new RTCIceCandidate(msg.ice));
        } else if (msg.sdp.type === 'offer') {
          this.logs.push('received offer');
          this.rtc
            .setRemoteDescription(new RTCSessionDescription(msg.sdp))
            .then(() => this.rtc.createAnswer())
            .then((answer) => this.rtc.setLocalDescription(answer))
            .then(() => this.sendMessage(JSON.stringify({ sdp: this.rtc.localDescription })));
        } else if (msg.sdp.type === 'answer') {
          this.logs.push('set remote description from answer');
          this.rtc.setRemoteDescription(new RTCSessionDescription(msg.sdp));
        } else {
          this.logs.push('unsupported message: ' + data.message);
        }
      } catch (error) {
        console.log(error);
        this.logs.push(error);
      }
    }
  }

  private mounted() {
    this.$store.dispatch('loadSession').then(() => {
      this.loading = false;
    });
  }

  private getStarted(timestamp: number) {
    return new Date(timestamp).toString();
  }
}
